<template>
  <div>
    <label>{{ label }}</label>
    <div class="nt-textarea" :class="[error ? 'nt-textarea--error' : '', getTheme]">
      <textarea :id="id" :name="name" :placeholder="placeholder" v-model.trim="selected" @input="changeForm" rows="4" :maxlength="maxLength" @blur="validateOnBlur"></textarea>
    </div>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
    <div class="nt-form-text-helper" v-if="helperText">{{ helperText }}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'nt-textarea',
  props: {
    id: {
      type: String,
      default: 'textarea'
    },
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    validators: {
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: 'default'
    },
    helperText: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      selected: null,
      error: null
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]
    }
  },
  computed: {
    getTheme() {
      return `nt-textarea--${this.theme}`
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data
    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.selected
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
  },
  methods: {
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.selected
      })
    },
    validateOnBlur() {
      this.changeForm()
      this.$parent.$emit('field-blur', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .nt-textarea {
    & textarea {
      display: flex;
      width: 100%;
      font-size: 22px;
      outline: none;
      border: 1px solid rgb(184, 184, 184);
      border-radius: 2px;
      padding: 20px;

      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-weight: 300;
        color: rgb(204, 204, 204);
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        font-weight: 300;
        color: rgb(204, 204, 204);
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
        font-weight: 300;
        color: rgb(204, 204, 204);
      }
    }
    
    &--error {
      textarea {
        border-color: #bd081a;
      }
    }

    &--small {
      textarea {
        padding: 10px;
        font-size: 1rem;
      }
    }
  }
</style>
